import { styled } from '@linaria/react';

export const Container = styled.span<{ width: number }>`
	width: ${({ width }) => `${width}ch`};
`;
